// src/components/steps/AddressInfo.js
import React from "react";
import { Row, Col, Form, Input } from "antd";

export default function AddressInfo() {
  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} sm={8}>
        <Form.Item name="city" label="City" rules={[{ required: true, message: "City is required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={8}>
        <Form.Item name="state" label="State" rules={[{ required: true, message: "State is required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={8}>
        <Form.Item name="pin_code" label="Pin code" rules={[{ required: true, message: "Pin code is required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item name="country" label="Country" rules={[{ required: true, message: "Country is required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item name="address" label="Address" rules={[{ required: true, message: "Address is required" }]}>
          <Input.TextArea rows={3} />
        </Form.Item>
      </Col>
    </Row>
  );
}
